import * as React from 'react';
import { Feature } from '@tencent/workbench';
import BaseDrawerFeature from '@framework/workbench/common/feature/base-drawer-feature';
import Dropdown from '@src/framework/frame-pc/components/dropdown';
import ToolbarManager, { SelectElementTypes } from '@src/framework/editor/src/js/constants/toolbar-data';
import TemplateGridMenu from '@src/framework/frame/components/tool-bar/menu/template-grid-menu';
import Provider from '@src/framework/frame/components/provider';
import styles from './layout-change.less';
import ScaleSlide from '@editor/src/page/index/components/canvas/scale-slide';
import { RenderPostionType } from '@src/js/constant';
import { SlideSizeType } from '@src/slide/domain/ui-model/element-modeles/property/slide-size/slide-size.interface';
import i18n from '@i18next/i18n';

const HEIGHT = 50;

@Feature()
export class LayoutChangeFeature extends BaseDrawerFeature {
    private dropDom: Dropdown | null;
    private containerId = 'layout-change-container';
    public getLayoutChangeContent(): React.ReactElement {
        const { dropdown } = ToolbarManager.getGroupListByType(SelectElementTypes.TEMPLATE);
        const { themeName, layoutName, currentSlide, slideSizeType } = this.getCurrentSlideInfo();
        if (!currentSlide) return <></>;
        const previewStyle = this.getPreviewStyle(slideSizeType);
        return currentSlide && (
            <div id={this.containerId} className={styles.container}>
                <div className={styles.preview} style={{
                    flex: `0 0 ${previewStyle.containerWidth}px`,
                }}>
                    <ScaleSlide
                        width={previewStyle.scaleSlideWidth}
                        height={HEIGHT}
                        slideModel={currentSlide}
                        isTemplate={true}
                        region={RenderPostionType.TEMPLATE}
                        styles={this.getInsideStyles()}
                        isSingletonFromDrawer={true}
                    />
                </div>
                <div className={styles.text}>
                    <p className={styles.themeName}>{i18n.t(themeName?.replace(/\u200B/g, ''))}</p>
                    <p className={styles.layoutName}>{i18n.t(layoutName)}</p>
                </div>
                <div className={styles.dropdown}><img src={dropdown.dropIcon}/></div>
                <Dropdown belongID={this.containerId} hasShadow={false} ref={(ref) => {
                    this.dropDom = ref;
                }}
                scrollable={false} offsetX={-268} offsetY={-64} onVisibleChange={this.handleOnVisibleChange}>
                    {this.getDropContent(dropdown)}
                </Dropdown>
            </div>
        );
    }

    public getCurrentSlideInfo() {
        const { currentSlide } = this.getSelectionService();
        const { presentation } = this.getUiDataService();
        return {
            themeName: currentSlide?.getRelationMasterModel()?.themeName,
            layoutName: currentSlide?.getRelationLayoutModel()?.name,
            currentSlide,
            slideSizeType: presentation.props.slideSizeType,
        };
    }

    private getPreviewStyle(slideSizeType) {
        const is4To3 = slideSizeType === SlideSizeType.SLIDE_SIZE_4_3;
        const width4To3 = HEIGHT * 4 / 3;
        const widthOther = HEIGHT * 16 / 9;
        return {
            containerWidth: is4To3 ? (width4To3 + 2) : (widthOther + 2),
            scaleSlideWidth: is4To3 ? width4To3 : widthOther,
        };
    }

    private getDropContent(dropdown) {
        const masters = this.getUiDataService().presentation.masterList;
        if (masters[0]?.layoutList.length > 0) {
            dropdown.masterList = masters;
        }
        return (
            <TemplateGridMenu
                {...dropdown}
                showSelected={true}
                onMenuClick={this.handleMenuClick}
            />
        );
    }


    private handleMenuClick = (index: string, e) => {
        const [masterIndex, layoutIndex] = index.split('.');
        this.getSelectionService().currentSlide?.changeLayout(masterIndex, layoutIndex);
        this.dropDom?.hide();
    };

    private handleOnVisibleChange = (visible: boolean) => {
        const container = document.getElementById(this.containerId);
        if (!container) return;
        if (visible) {
            container.style.backgroundColor = 'rgba(51, 77, 102, 0.06)';
        } else {
            container.style.removeProperty('background-color');
        }
        const menuManager = this.getMenuManager();
        if (menuManager) {
            menuManager.isDropdownShown = visible;
        }
    };

    private getInsideStyles() {
        return {
            scaleSlideStyle: {
                top: 0,
                left: 0,
            },
            containerStyle: {
                outline: 'none',
                left: '50%',
                transform: 'translateX(-50%)',
            },
        };
    }
}
